import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { CoalService } from 'app/services/coal.service';
import { AppState, selectAuthState, selectUtilsState } from 'app/store/app.states';
import { BehaviorSubject, switchMap, take, withLatestFrom, zip } from 'rxjs';
import { Store } from '@ngrx/store';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { UpdateData } from 'app/store/actions/auth.actions';
import { BaseService } from 'app/services/base.service';
import { cloneDeep } from 'lodash';
import { SeleccionarEmpresa } from 'app/store/actions/utils.action';
import { AuthService } from 'app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'settings-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit, OnChanges {
  @Input() idEmpresa;
  @Input() Observable$: BehaviorSubject<any>;

  accountForm: FormGroup;
  catalogos: any;
  catTipoPersona: any[] = [];
	catGiro: { idCatalogo: number; nombre: string; descripcion: any; valor: string; }[] = [];
	catGiroMoral: { idCatalogo: number; nombre: string; descripcion: any; valor: string; }[] = [];
	catGiroFisica: { idCatalogo: number; nombre: string; descripcion: any; valor: string; }[] = [];
	catRegimen: { idCatalogo: number; nombre: string; descripcion: any; valor: string; }[] = [];
	catTamanio: { idCatalogo: number; nombre: string; descripcion: any; valor: string; }[] = [];
  catRegimenMoral: any;
  catRegimenFisico: any;
	catReg: any[];
  operacion: any;
  fileCer;
  fileKey;
  uuidPattern = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;

  user;
  state;
  api = 'ope-empresas';
  dataField = ['logo'];
  files: any[] = [];

  constructor(
    private _formBuilder: FormBuilder,
    private coalService: CoalService,
		private snackBar: MatSnackBar,
    private store: Store<AppState>,
    private baseService: BaseService,
    private router: Router,
    private authService: AuthService
  ) {

  }
  ngOnInit(): void {
    if(this.idEmpresa == 0) {

      this.store.dispatch(
          SeleccionarEmpresa({ empresaSeleccionada: null })
      );
    }
    this.getOperacion();
    this.getCatalogo();

    this.accountForm = this._formBuilder.group({
			// Descripción de la operación
			idOperacion: [null],
      rfc: [null, [Validators.required, Validators.pattern(this.uuidPattern)]],
			razonSocial: [null, [Validators.required, Validators.maxLength(350)]],
			nombreComercial: [null, [Validators.maxLength(350)]],
			idTipoPersona: [null, Validators.required],
			idGiro: [null, Validators.required],
			idRegimenFiscal: [null, Validators.required],
			idTamanioEmpresa: [null, Validators.required],
			contactoEmail: [null, [
                Validators.required,
                Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
            ]],
			contactoTelefono: [null, [Validators.required, Validators.maxLength(14), Validators.minLength(10)]],
			folioInicio: [null],
		});

    if (this.idEmpresa)
      this.accountForm.controls.rfc.disable();
    else {
      this.accountForm.controls.rfc.enable();
    }

    this.state = cloneDeep(this.baseService.getUserData());
    this.user = this.state.user;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.idEmpresa?.currentValue) {
      this.accountForm?.controls?.rfc?.disable();
      this.getOperacion();
    } else {
      this.accountForm?.controls?.rfc?.enable();
      this.resetForm();
    }
  }

  resetForm () {
    this.accountForm?.controls?.idOperacion?.setValue(null);
    this.accountForm?.controls?.rfc?.setValue(null);
    this.accountForm?.controls?.razonSocial?.setValue(null);
    this.accountForm?.controls?.nombreComercial?.setValue(null);
    this.accountForm?.controls?.idTipoPersona?.setValue(null);
    this.accountForm?.controls?.idGiro?.setValue(null);
    this.accountForm?.controls?.idRegimenFiscal?.setValue(null);
    this.accountForm?.controls?.idTamanioEmpresa?.setValue(null);
    this.accountForm?.controls?.contactoEmail?.setValue(null);
    this.accountForm?.controls?.contactoTelefono?.setValue(null);
    this.files = [];
    this.operacion = null;
  }

  getOperacion() {
    return new Promise((resolve, reject) => {
        this.store.dispatch(MostrarSpinner());
        this.coalService.getService(`ope-empresas?filters[id]=${this.idEmpresa}&populate[0]=cat_tipo_persona,cat_giro,cat_tamanio_empresa,cat_regimen_fiscal,logo`).subscribe({
            next: (res: any) => {
                this.store.dispatch(OcultarSpinner());
                this.operacion = res?.data[0];
                this.changeOperation(this.operacion);
                this.infoUserModule();
                resolve({ success: true, data: res?.data });
            }, error: (error: any) => {
                console.log(error);
                this.store.dispatch(OcultarSpinner());
                resolve({ success: false, error: error });
            }}
        );
    });
  }

  infoUserModule() {
    this.store.select(selectAuthState).pipe(
      take(1), // Esto asegura que sólo tomes la primera emisión y luego te desuscribas
      switchMap((state: any) => {
        const userId = state.seguridad.user.id;
        return this.coalService.getService(`ope-empresas?filters[users_permissions_users][id]=${userId}&populate=logo,ope_empresa_estatus_hs.ope_empresa_estatus&sort=createdAt:ASC`);
      }),
      withLatestFrom(this.store.select(selectUtilsState)) // Con esto combinas el observable anterior con el estado actual de utils
    ).subscribe(([res, utilsState]: [any, any]) => {
      const empresaSeleccionada = utilsState?.empresaSeleccionada?.id;
      const filteredEmpresa = res.data.find(empresa => empresa.id === empresaSeleccionada);
      this.store.dispatch(SeleccionarEmpresa({ empresaSeleccionada: filteredEmpresa }));
      localStorage.setItem("empresaSeleccionada", JSON.stringify(filteredEmpresa));

      // if (!filteredEmpresa || filteredEmpresa.id !== empresaSeleccionada) {
      //   // Verifica si la empresa seleccionada es diferente antes de despachar la acción
      //   this.store.dispatch(SeleccionarEmpresa({ empresaSeleccionada: filteredEmpresa }));
      //   localStorage.setItem("empresaSeleccionada", JSON.stringify(filteredEmpresa));
      // }
    }, (error: any) => {
      this.store.dispatch(OcultarSpinner());
    });
  }

  changeOperation (operacion: any) {
    this.files = [];
    this.files = [operacion?.attributes?.logo?.data?.attributes];
    this.api = `ope-empresas/${this.operacion?.id}`;
    this.accountForm.controls.idOperacion.setValue(operacion?.id);
    this.accountForm.controls.rfc.setValue(operacion?.attributes?.rfc);
    this.accountForm.controls.razonSocial.setValue(operacion?.attributes?.razonSocial);
    this.accountForm.controls.nombreComercial.setValue(operacion?.attributes?.nombreComercial);
    this.accountForm.controls.contactoEmail.setValue(operacion?.attributes?.email);
    this.accountForm.controls.contactoTelefono.setValue(operacion?.attributes?.telefono);
    this.accountForm.controls.idTipoPersona.setValue(operacion?.attributes?.cat_tipo_persona?.data?.id);
    this.setDataGiro();
    this.accountForm.controls.idGiro.setValue(operacion?.attributes?.cat_giro?.data?.id);
    this.accountForm.controls.idRegimenFiscal.setValue(operacion?.attributes?.cat_regimen_fiscal?.data?.id);
    this.accountForm.controls.idTamanioEmpresa.setValue(operacion?.attributes?.cat_tamanio_empresa?.data?.id);
  }

  getCatalogo() {
		zip(
      this.coalService.getService('cat-tipo-personas'),
      this.coalService.getService('cat-giros'),
      this.coalService.getService('cat-regimenes-fiscal'),
      this.coalService.getService('cat-tamanio-empresas')
    ).subscribe((res: any) => {
      this.catTipoPersona = res[0].data;
      this.catGiroMoral = res[1].data.filter(x => x.attributes.aplicaMoral);
      this.catGiroFisica = res[1].data.filter(x => x.attributes.aplicaFisico);
      this.catRegimenMoral = res[2].data.filter(x => x.attributes.aplicaMoral);
      this.catRegimenFisico = res[2].data.filter(x => x.attributes.aplicaFisico);
      this.catTamanio = res[3].data;
    }, (error: any) => {
      console.log(error);
    });
	}

  setDataGiro() {
    if ( this.catTipoPersona.find(x => x.id === this.accountForm.value.idTipoPersona)?.attributes?.nombre?.toUpperCase()?.indexOf("MORAL") > -1 ) {
      this.catReg = this.catRegimenMoral;
      this.catGiro = this.catGiroMoral;
    } else {
      this.catReg = this.catRegimenFisico;
      this.catGiro = this.catGiroFisica;
    }
    this.accountForm.controls.idRegimenFiscal.setValue(null);
    this.accountForm.controls.idGiro.setValue(null);
	}

  actualizarEmpresa() {
    this.accountForm.markAllAsTouched();
    this.accountForm.updateValueAndValidity();

    let data = {
      "data": {
        "cat_tipo_persona": this.accountForm.value.idTipoPersona,
        "cat_giro": this.accountForm.value.idGiro,
        "razonSocial": this.accountForm.value.razonSocial,
        "nombreComercial": this.accountForm.value.nombreComercial,
        "cat_regimen_fiscal": this.accountForm.value.idRegimenFiscal,
        "cat_tamanio_empresa": this.accountForm.value.idTamanioEmpresa,
        "email": this.accountForm.value.contactoEmail,
        "telefono": this.accountForm.value.contactoTelefono
      }
    }

    this.store.dispatch(MostrarSpinner());
    this.coalService.putService(`ope-empresas/${this.operacion.id}`, data).subscribe({
        next: (emp: any) => {
            this.actualizaEmpresas(emp.data.id).then(res => {
                this.getOperacion().then((res: any) => {
                    if(res.success) {
                        this.store.dispatch(OcultarSpinner());
                        this.openSnackBar('Datos guardados correctamente', 2500, 'outline', 'success');
                        this.goToStamp();
                    } else {
                        console.log(res);
                        this.store.dispatch(OcultarSpinner());
                        this.openSnackBar('Ocurrió un error, favor de intentar nuevamente', 2500, 'outline', 'success');
                    }
                });
            }).catch(error => {
                console.log(error);
                this.store.dispatch(OcultarSpinner());
                this.openSnackBar('Ocurrió un error, favor de intentar nuevamente', 2500, 'outline', 'success');
            });
      }, error:(error: any) => {
        console.log(error);
        this.store.dispatch(OcultarSpinner());
        this.openSnackBar('Ocurrió un error, favor de intentar nuevamente', 2500, 'outline', 'success');
      }}
    );
  }

  guardarEmpresa() {
    this.accountForm.markAllAsTouched();
    this.accountForm.updateValueAndValidity();

    if(!this.accountForm.valid) {
      this.openSnackBar('Debe llenar todos los campos', 2500, 'outline', 'success');
      return
    }

    let data = {
      "data": {
        "rfc": this.accountForm.value.rfc,
        "cat_tipo_persona": this.accountForm.value.idTipoPersona,
        "cat_giro": this.accountForm.value.idGiro,
        "razonSocial": this.accountForm.value.razonSocial,
        "nombreComercial": this.accountForm.value.nombreComercial,
        "cat_regimen_fiscal": this.accountForm.value.idRegimenFiscal,
        "cat_tamanio_empresa": this.accountForm.value.idTamanioEmpresa,
        "email": this.accountForm.value.contactoEmail,
        "telefono": this.accountForm.value.contactoTelefono,
        "users_permissions_users": {
          "connect": [this.user?.id]
        }
      }
    }

    this.store.dispatch(MostrarSpinner());
    this.coalService.postService(`ope-empresas`, data).subscribe({
      next: (emp: any) => {
        // Recuperar la nueva empresa para obtener su estatus
        this.actualizaEmpresas(emp.data.id).then(res => {
            this.store.dispatch(OcultarSpinner());
            this.openSnackBar('Datos guardados correctamente', 2500, 'outline', 'success');
            this.goToStamp();
            this.Observable$.next(1);
        }).catch(error => {
            console.log(error);
            this.store.dispatch(OcultarSpinner());
            this.openSnackBar('Ocurrió un error, favor de intentar nuevamente', 2500, 'outline', 'success');
        });
      }, error: (error: any) => {
        console.log(error);
        this.store.dispatch(OcultarSpinner());
        this.openSnackBar('Ocurrió un error, favor de intentar nuevamente', 2500, 'outline', 'success');
      }
    });
  }

  actualizaEmpresas(idEmpresa: number) {
    return new Promise((resolve, reject) => {
        this.getEmpresas().then((res: any) => {
            const myClonedState = { ...this.state, company: Object.assign([], res.data) };
            this.store.dispatch(UpdateData({seguridad: myClonedState}));

            const empresa = res.data.find(e => e.id == idEmpresa);
            this.store.dispatch(SeleccionarEmpresa({empresaSeleccionada: empresa}));

            resolve({ success: true });
        }).catch((error: any) => reject(error));
    });
  }

  getEmpresas() {
    return new Promise((resolve, reject) => {
        const query = `ope-empresas?filters[users_permissions_users][id]=${this.user.id}&populate=logo,ope_empresa_estatus_hs.ope_empresa_estatus&sort=createdAt:ASC`;
        this.coalService.getService(query)
            .subscribe({ next: (res: any) => resolve(res), error: (error: any) => reject(error) });
    });
  }

  goToStamp() {
    setTimeout(() => {
        this.router.navigate(['cuenta/perfil'], { queryParams: { key: 'stamp' } });
        this.Observable$.next(1);
    }, 500);
  }

  /*addCompanyToState(company) {
    this.state.company.push(company);
    this.store.dispatch(UpdateData({seguridad: this.state}));
    const empresa = this.state.seguridad.company.find(e => e.id == this.idEmpresa);
    this.store.dispatch(SeleccionarEmpresa({empresaSeleccionada: empresa}));
    // Redireccionar a la seccion stamp de la configuracion de la compañia
    this.router.navigate(['cuenta/perfil'], { queryParams: { key: 'stamp' } });
  }*/

  openSnackBar(
    message: string,
    duration: number = 5000,
    appearance: 'fill' | 'outline' | 'soft' = 'fill',
    type: 'info' | 'success' | 'error' = 'info'
  ): void {
      const config: MatSnackBarConfig = {
          duration: duration,
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          panelClass: [`snackbar-type-${appearance}-${type}`],
      };
      this.snackBar.open(message, 'Ok', config);
  }


}
